import { useStore } from '@xyflow/react';
import type { AlignGuide } from '@ukrop-nm/shared';

/** Transient alignment guides while dragging nodes (flow → screen via viewport). */
export function AlignGuidesOverlay({ guides }: { guides: AlignGuide[] }) {
  const transform = useStore((s) => s.transform);
  const [tx, ty, zoom] = transform;

  if (guides.length === 0) return null;

  return (
    <div className="ukrop-align-guides" aria-hidden>
      {guides.map((g, i) =>
        g.orientation === 'v' ? (
          <div
            key={`v-${i}-${g.position}`}
            className="ukrop-align-guide ukrop-align-guide--v"
            style={{ transform: `translateX(${tx + g.position * zoom}px)` }}
          />
        ) : (
          <div
            key={`h-${i}-${g.position}`}
            className="ukrop-align-guide ukrop-align-guide--h"
            style={{ transform: `translateY(${ty + g.position * zoom}px)` }}
          />
        ),
      )}
    </div>
  );
}
